export default "__VITE_ASSET__B1s8o9jJ__"